<dialog-header [label]="'SENSOR.SENSOR_BIAS' | translate: {sensorTitle: sensorTitle}" [dialogRef]='dialogRef' (mousedown)="windowClick()" [object]='this'></dialog-header>
<mat-dialog-content style="min-width: 300px">
  <div fxLayout="column">
    <mat-grid-list cols="3" rowHeight="4em">
      <mat-grid-tile>
        <mat-form-field class="mat-form-field-left" [hintLabel]="'SENSOR.RANGE' | translate"><input matInput readonly [value]="range"></mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field [hintLabel]="'SENSOR.RANGE_ACCURACY' | translate"><input matInput readonly [value]="rangeAcc"></mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-checkbox disabled [checked]="rangeRegistered"><div class="registered-label">{{'SENSOR.REGISTERED' | translate}}</div></mat-checkbox>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="mat-form-field-left" [hintLabel]="'SENSOR.AZIMUTH' | translate"><input matInput readonly [value]="azimuth"></mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field [hintLabel]="'SENSOR.AZIMUTH_ACCURACY' | translate"><input matInput readonly [value]="azimuthAcc"></mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-checkbox disabled [checked]="azimuthRegistered"><div class="registered-label">{{'SENSOR.REGISTERED' | translate}}</div></mat-checkbox>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field class="mat-form-field-left" [hintLabel]="'SENSOR.ELEVATION' | translate"><input matInput readonly [value]="elevation"></mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field [hintLabel]="'SENSOR.ELEVATION_ACCURACY' | translate"><input matInput readonly [value]="elevationAcc"></mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-checkbox disabled [checked]="elevationRegistered"><div class="registered-label">{{'SENSOR.REGISTERED' | translate}}</div></mat-checkbox>
      </mat-grid-tile>
    </mat-grid-list>
    <p></p>
    <mat-card>
      <mat-card-title>{{'SENSOR.POSITION' | translate}}</mat-card-title>
      <mat-grid-list cols="4" rowHeight="4em">
        <mat-grid-tile [colspan]="3">
          <mat-form-field [hintLabel]="'SENSOR.LOCATION' | translate"><input matInput readonly [value]="location"></mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1">
          <mat-form-field [hintLabel]="'SENSOR.ALTITUDE' | translate"><input matInput readonly [value]="altitude"></mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
            <mat-checkbox disabled [checked]="locationRegistered"><div class="registered-label">{{'SENSOR.REGISTERED' | translate}}</div></mat-checkbox>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="2">
            <mat-checkbox disabled [checked]="wellLocated"><div class="registered-label">{{'SENSOR.WELL_LOCATED' | translate}}</div></mat-checkbox>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card>
  </div>  
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="resetBiases()" >{{'SENSOR.RESET_BIASES' | translate}}</button>
  <button mat-stroked-button (click)="unregister()" >{{'SENSOR.UNREGISTER' | translate}}</button>
  <button mat-stroked-button [mat-dialog-close]="true">{{'SENSOR.CLOSE' | translate}}</button>
</mat-dialog-actions>
